/**
 * @generated SignedSource<<9e6144dc4e6a9e4d88dae94c397b0c6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackagePurchaseQuery$variables = {
  memberPackageId: string;
  orderId: string;
};
export type StorePackagePurchaseQuery$data = {
  readonly memberPackage: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrder_memberPackage">;
  } | null | undefined;
  readonly order: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreProductOrder_order">;
  } | null | undefined;
};
export type StorePackagePurchaseQuery = {
  response: StorePackagePurchaseQuery$data;
  variables: StorePackagePurchaseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberPackageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "memberPackageId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orderId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageDueDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorePackagePurchaseQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoreProductOrder_memberPackage"
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoreProductOrder_order"
              }
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorePackagePurchaseQuery",
    "selections": [
      {
        "alias": "memberPackage",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "squareCard",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardBrand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastFour",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isPackage"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DisplayInApp",
                    "kind": "LinkedField",
                    "name": "displayInApp",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billingType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeUntilPeriod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeUntilPeriodUnit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeUntilPeriodType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingOption",
                    "kind": "LinkedField",
                    "name": "billingOptions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingCharge",
                        "kind": "LinkedField",
                        "name": "billingCharges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "frequency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareItemVariation",
                            "kind": "LinkedField",
                            "name": "squareVariation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minimumCommitmentMonths",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "order",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalTaxes",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberPackageConnection",
                "kind": "LinkedField",
                "name": "memberPackages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberPackageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberPackage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "status",
                                "value": "OPEN"
                              }
                            ],
                            "concreteType": "OrderConnection",
                            "kind": "LinkedField",
                            "name": "orders",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Order",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orders(status:\"OPEN\")"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderLineItemConnection",
                "kind": "LinkedField",
                "name": "lineItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderLineItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "price",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AppliedDiscount",
                                "kind": "LinkedField",
                                "name": "appliedDiscounts",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amountCents",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BasicLineItem",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Order",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4e05792ea10ba29efb1f9c7a8d2b0417",
    "id": null,
    "metadata": {},
    "name": "StorePackagePurchaseQuery",
    "operationKind": "query",
    "text": "query StorePackagePurchaseQuery(\n  $orderId: ID!\n  $memberPackageId: ID!\n) {\n  memberPackage: node(id: $memberPackageId) {\n    __typename\n    ... on MemberPackage {\n      ...StoreProductOrder_memberPackage\n    }\n    id\n  }\n  order: node(id: $orderId) {\n    __typename\n    ... on Order {\n      ...StoreProductOrder_order\n    }\n    id\n  }\n}\n\nfragment PackageOrderSummary_order on Order {\n  id\n  total\n  totalTaxes\n  ...useIsPackageOrderDue_order\n  memberPackages {\n    edges {\n      node {\n        id\n        orders(status: OPEN) {\n          edges {\n            node {\n              packageDueDate\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n  lineItems {\n    edges {\n      node {\n        __typename\n        id\n        name\n        price\n        ... on BasicLineItem {\n          appliedDiscounts {\n            name\n            amountCents\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PaymentMethod_squareCardOnFile on SquareCardOnFile {\n  id\n  expMonth\n  expYear\n  cardBrand\n  lastFour\n}\n\nfragment StorePackageSummary_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  billingType\n  startOn\n  endOn\n  activeUntilPeriod\n  activeUntilPeriodUnit\n  activeUntilPeriodType\n  ...useGetPackagePriceMap_package\n  ...useGetMinimumCommitment_package\n}\n\nfragment StoreProductOrder_memberPackage on MemberPackage {\n  id\n  customer {\n    id\n  }\n  squareCard {\n    ...PaymentMethod_squareCardOnFile\n    id\n  }\n  package {\n    __typename\n    ...usePackageDisplayName_package\n    ...StorePackageSummary_package\n    id\n  }\n}\n\nfragment StoreProductOrder_order on Order {\n  ...PackageOrderSummary_order\n}\n\nfragment useGetMinimumCommitment_package on Package {\n  __isPackage: __typename\n  id\n  billingOptions {\n    minimumCommitmentMonths\n  }\n}\n\nfragment useGetPackagePriceMap_package on Package {\n  __isPackage: __typename\n  billingOptions {\n    billingCharges {\n      frequency\n      squareVariation {\n        amount\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useIsPackageOrderDue_order on Order {\n  packageDueDate\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n"
  }
};
})();

(node as any).hash = "c1c63414175ec20ac1e6f46725a44082";

export default node;
